@if (
  {
    violations: violations$ | async,
    groups: groups$ | async
  };
  as STATE
) {
  <article class="advertiser-sector-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          [title]="sector()?.id ? 'Modifier un secteur' : 'Créer un secteur'"
          [description]="
            sector()?.id
              ? 'Renseigner le champ ci-dessous pour la modification d\'un secteur'
              : 'Renseigner le champ ci-dessous pour la création d\'un secteur'
          "
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <mat-label>Nom du secteur *</mat-label>
            <mat-form-field color="primary">
              <input
                matInput
                formControlName="name"
                placeholder="Nom du secteur"
                trim="blur"
              />
              <mat-error
                *ngIf="
                  $any(form.get('name'))?.getError('httpError') as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <article>
            <mat-label>Groupe *</mat-label>
            <mat-form-field>
              <mat-select
                formControlName="parentId"
                placeholder="Sélectionner le groupe"
              >
                @for (group of STATE.groups?.items; track group) {
                  <mat-option [value]="group.id">{{ group.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </article>

          <button
            type="submit"
            [attr.loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}
